import { Pagination } from '@/Domain/Procedures/RepositoryModifiers/Pagination'
import { ProcedureFilters } from '@/Domain/Procedures/RepositoryModifiers/ProcedureFilters'
import { ProcedureOrdering } from '@/Domain/Procedures/RepositoryModifiers/ProcedureOrdering'
import { AccountId } from '@/Domain/Account'
import {
  ProcedureNotFoundError,
  Procedure,
  ProcedureId,
  ProcedureStatus,
  ProcedureType,
  ProcedureDateLimit,
  Province,
  UserProcedure,
  ApplicationStatus,
  ProcedureBatches,
  UserProcedureRepository
} from '@/Domain/Procedures'
import { DogaInfo, DogaUrl, DogaDate, DogaNumber } from '@/Domain/Procedures/Doga'
import {
  CelebrationInfo,
  CelebrationDate,
  CelebrationPlace,
  CelebrationTime
} from '@/Domain/Procedures/Celebration'
const createProcedures = () => {
  return [
    new Procedure(
      new ProcedureId('CO-PX-2019-1'),
      ProcedureType.POXA,
      ProcedureStatus.PUBLISHED,
      Province.A_CORUNA,
      new DogaInfo(
        new DogaDate('27/11/2019'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Co'),
        new CelebrationDate('14/01/2020'),
        new CelebrationTime('11:00')
      ),
      new ProcedureDateLimit('10/12/2019')
    ),
    new Procedure(
      new ProcedureId('CO-PX-2019-2'),
      ProcedureType.POXA,
      ProcedureStatus.PUBLISHED,
      Province.A_CORUNA,
      new DogaInfo(
        new DogaDate('27/03/2020'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Co'),
        new CelebrationDate('30/04/2020'),
        new CelebrationTime('11:00')
      ),
      new ProcedureDateLimit('15/04/2020')
    ),
    new Procedure(
      new ProcedureId('CO-PN-2019-2'),
      ProcedureType.NEGOCIADO,
      ProcedureStatus.PUBLISHED,
      Province.A_CORUNA,
      new DogaInfo(
        new DogaDate('27/03/2020'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Co'),
        new CelebrationDate('30/04/2020'),
        new CelebrationTime('11:00')
      ),
      new ProcedureDateLimit('15/04/2020')
    ),
    new Procedure(
      new ProcedureId('OU-PN-2019-1'),
      ProcedureType.NEGOCIADO,
      ProcedureStatus.PUBLISHED,
      Province.OURENSE,
      new DogaInfo(
        new DogaDate('27/11/2019'),
        new DogaNumber(245),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Ou'),
        new CelebrationDate('26/11/2019'),
        new CelebrationTime('14:00')
      ),
      new ProcedureDateLimit('04/11/2019')
    ),
    new Procedure(
      new ProcedureId('LU-AD-2020-1'),
      ProcedureType.ALLEAMENTO_DIRECTO,
      ProcedureStatus.PUBLISHED,
      Province.LUGO,
      new DogaInfo(
        new DogaDate('04/11/2019'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Lu'),
        new CelebrationDate('24/02/2020'),
        new CelebrationTime('10:00')
      ),
      new ProcedureDateLimit('03/02/2020')
    ),
    new Procedure(
      new ProcedureId('PO-PX-2020-01'),
      ProcedureType.ALLEAMENTO_DIRECTO,
      ProcedureStatus.PUBLISHED,
      Province.LUGO,
      new DogaInfo(
        new DogaDate('04/11/2019'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Lu'),
        new CelebrationDate('24/02/2020'),
        new CelebrationTime('10:00')
      ),
      new ProcedureDateLimit('03/02/2020')
    ),
    new Procedure(
      new ProcedureId('PO-AD-2020-1'),
      ProcedureType.ALLEAMENTO_DIRECTO,
      ProcedureStatus.PUBLISHED,
      Province.LUGO,
      new DogaInfo(
        new DogaDate('04/11/2019'),
        new DogaNumber(150),
        new DogaUrl('')
      ),
      new CelebrationInfo(
        new CelebrationPlace('Lu'),
        new CelebrationDate('24/02/2020'),
        new CelebrationTime('10:00')
      ),
      new ProcedureDateLimit('03/02/2020')
    )
  ]
}
async function wait (ms: number) {
  return new Promise(resolve => {
    setTimeout(resolve, ms)
  })
}

export class InMemoryUserProcedureRepository implements UserProcedureRepository {
  async byUser (
    accountId: AccountId,
    pagination: Pagination,
    filters: ProcedureFilters,
    ordering: ProcedureOrdering
  ): Promise<UserProcedure[]> {
    const duration = 300
    await wait(duration)
    const procedures = createProcedures()
    const startItem = (pagination.page - 1) * pagination.itemsPerPage
    const endItem = pagination.page * pagination.itemsPerPage
    const slicedProcedures = procedures.slice(startItem, endItem)
    const filteredProcedures = this.filterProcedures(slicedProcedures, filters)
    const sortedProcedures = this.sortProcedures(filteredProcedures, ordering)
    const userProcedures = sortedProcedures.map(current => {
      return new UserProcedure(current, ApplicationStatus.SUBSANATION, new ProcedureBatches('050/10-050/11'))
    })
    return userProcedures
  }

  // eslint-disable-next-line
  async totalItemsByUserCount (accountId: AccountId, filters: ProcedureFilters): Promise<number> {
    // const duration = (Math.floor(Math.random() * 3) + 1) * 1000
    const duration = 100
    await wait(duration)
    const procedures = createProcedures().slice(0, 1)
    const filteredProcedures = this.filterProcedures(procedures, filters)
    return filteredProcedures.length
  }
  //
  // eslint-disable-next-line
  async byUserbyId (accountId: AccountId, procedureId: ProcedureId): Promise<Procedure> {
    const duration = 300
    await wait(duration)
    const procedures = createProcedures()
    const filteredProcedure = procedures.filter(current => {
      return current.procedureId() === procedureId.id
    })
    if (filteredProcedure.length === 0) {
      throw new ProcedureNotFoundError(`Procedure ${procedureId.id} not found!!!`)
    }
    return filteredProcedure[0]
  }

  private filterProcedures (procedures: Procedure[], filters: ProcedureFilters): Procedure[] {
    return procedures.filter(item => {
      let matches = true
      if (filters.code) {
        matches = matches && item.procedureId().indexOf(filters.code) !== -1
      }
      if (filters.province) {
        matches = matches && item.province() === parseInt(filters.province, 10)
      }
      if (filters.procedureType) {
        matches = matches && item.procedureType() === filters.procedureType
      }
      if (filters.dateFrom) {
        const procedureDate = this.convertDate(item.dateLimit() + '20')
        const convertedDateFrom = this.convertDate(filters.dateFrom)
        matches = matches && procedureDate.localeCompare(convertedDateFrom) >= 0
      }
      if (filters.dateTo) {
        const procedureDate = this.convertDate(item.dateLimit() + '20')
        const convertedDateTo = this.convertDate(filters.dateTo)
        matches = matches && procedureDate.localeCompare(convertedDateTo) <= 0
      }
      return matches
    })
  }

  private convertDate (date: string): string {
    const items = date.split('/')
    return `${items[2]}-${items[1]}-${items[0]}`
  }

  // eslint-disable-next-line
  private sortProcedures (procedures: Procedure[], ordering: ProcedureOrdering): Procedure[] {
    // const stringifiedOrderBy = ordering.orderBy as string
    const orderFunction = this.sortByCode
    /*
    if (stringifiedOrderBy === 'procedureType') {
      orderFunction = this.sortByProcedureType
    }
    if (stringifiedOrderBy === 'province') {
      orderFunction = this.sortByProvince
    }
    if (stringifiedOrderBy === 'date') {
      orderFunction = this.sortByDate
    }
    */
    return procedures.sort(orderFunction)
  }

  private sortByCode (a: Procedure, b: Procedure): number {
    return a.procedureId().localeCompare(b.procedureId())
  }

  /*
  private sortByProcedureType (a: Procedure, b: Procedure): number {
    return a.procedureType().localeCompare(b.procedureType())
  }

  private sortByDate (a: Procedure, b: Procedure): number {
    const dateA = this.convertDate(a.dateLimit() + '20')
    const dateB = this.convertDate(b.dateLimit() + '20')
    if (dateA === dateB) {
      return 0
    }
    return dateA > dateB ? 1 : -1
  }

  private sortByProvince (a: Procedure, b: Procedure): number {
    return a.province() - b.province()
  }
  */
}
